import React, { Fragment, useState } from "react";
import { Link , useNavigate} from "react-router-dom";
// import DatePicker from "react-datepicker";
import useRequests from "../../../utils/useRequests";
import "react-datepicker/dist/react-datepicker.css";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import Snackbars from "../../../utils/Snackbars";

const AddUser = () => {
    const navigate = useNavigate();
    const { postRequest } = useRequests(); // Your custom hook for making API calls
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        phone:"",
        // aadhar: "",
    });
    const [AlertData, setAlertData] = React.useState({
           variant: '',
           message: '',
         });
       
         const resetAlertData = () => {
           setTimeout(() => {
             setAlertData((AlertData) => ({
               ...AlertData,
               variant: '',
               message: '',
             }));
           }, process.env.REACT_APP_ALERT_AUTO_CLOSE);
         };

    

    const validation1 = useFormik({
        enableReinitialize: true,
    
        initialValues: formData,
        validationSchema: Yup.object({
            first_name: Yup.string().required('First name is required'),
            last_name: Yup.string().required('Last name is required'),

          email: Yup.string()
            .email('Please enter a valid email!')
            .max(255)
            .required('Email is required'),
          phone: Yup.string()
            .matches(/^[0-9]{10}$/, 'Please enter a valid 10-digit phone number!')
            .required('Phone number is required'),
            // aadhar: Yup.string()
            //   .required('Aadhar Card is required')
            //   .matches(/^\d{12}$/, 'Aadhar Card must be exactly 12 digits'),
        }),
    onSubmit: async (values) => {
        // e.preventDefault();

        try {
            let submit1 = document.getElementById('submit1');
            submit1.disabled = true;
            submit1.textContent = ('Processing...');
            // Convert form data to JSON
            const jsonpar = JSON.stringify({
                first_name: values.first_name,
                last_name: values.last_name,
                email: values.email,
                phone: values.phone,
                // aadhar: values.aadhar,
            });

            // Make the POST request
            const res = await postRequest("user-add", jsonpar);

            // Handle the response
            if (res && res.code === 200) {
                setFormData({
                    first_name: "",
                    last_name: "",
                    email: "", 
                    phone:"",
                    // aadhar: ""
                });
                navigate('/user-list',{
                    state:{variant: "success",
                        message: "User added successfully!",}
                })
            } else {
                setAlertData((AlertData) => ({
                    ...AlertData,
                    variant: 'error',
                    message: res.message || "Failed to add user.",
                  }));
                  resetAlertData();
            }
            submit1.disabled = false;
            submit1.textContent = ('Add User');
        } catch (error) {
            console.error("Error: ", error);
            setAlertData((AlertData) => ({
                ...AlertData,
                variant: 'error',
                message: "An error occurred while adding the user.",
              }));
              resetAlertData();
        }
    }
    });
    return (
      <Fragment>
        <div className='d-sm-flex d-block justify-content-between align-items-center mb-4'>
          <h2 className='text-black font-w700 mb-0'>Add User</h2>
        </div>

        <div className='col-lg-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='basic-form'>
                {AlertData.message !== "" ? (
                  <Snackbars
                    variant={AlertData.variant}
                    message={AlertData.message}
                  />
                ) : (
                  ""
                )}
                <form>
                  <div className='row mb-3'>
                    <div className='form-group mb-3 col-md-6 col-xs-12'>
                      <label>First Name:</label>
                      <input
                        type='text'
                        className={`form-control ${
                          validation1.touched.first_name && validation1.errors.first_name
                            ? "is-invalid"
                            : ""
                        }`}
                        name='first_name'
                        placeholder='Enter First Name'
                        value={validation1.values.first_name || ""}
                        onChange={validation1.handleChange}
                        onBlur={validation1.handleBlur}
                        invalid={
                          validation1.touched.first_name &&
                          validation1.errors.first_name
                            ? true
                            : false
                        }
                        required
                      />
                      {validation1.touched.first_name &&
                      validation1.errors.first_name ? (
                        <div className='invalid-feedback'>
                          {validation1.errors.first_name}
                        </div>
                      ) : null}
                    </div>
                    <div className='form-group mb-3 col-md-6 col-xs-12'>
                      <label>Last Name:</label>
                      <input
                        type='text'
                        className={`form-control ${validation1.touched.last_name && validation1.errors.last_name ? 'is-invalid' : ''}`}
                            name="last_name"
                            placeholder="Enter last Name"
                            value={validation1.values.last_name || ''}
                            onChange={validation1.handleChange}
                            onBlur={validation1.handleBlur}
                            invalid={
                            validation1.touched.last_name && validation1.errors.last_name ? true : false
                            }
                            
                        />
                        {validation1.touched.last_name && validation1.errors.last_name ? (
                            <div className="invalid-feedback" >{validation1.errors.last_name}</div>
                        ) : null}
                    </div>
                    <div className='form-group mb-3 col-md-6 col-xs-12'>
                      <label>Email:</label>
                      <input
                        type='email'
                        className={`form-control ${validation1.touched.email && validation1.errors.email ? 'is-invalid' : ''}`}
                        name="email"
                        placeholder="xyz@gmail.com"
                        value={validation1.values.email || ''}
                        onChange={validation1.handleChange}
                        onBlur={validation1.handleBlur}
                        invalid={
                        validation1.touched.email && validation1.errors.email ? true : false
                        }
                        
                    />
                    {validation1.touched.email && validation1.errors.email ? (
                        <div className="invalid-feedback" >{validation1.errors.email}</div>
                    ) : null}
                    </div>
                    <div className='form-group mb-3 col-md-6 col-xs-12'>
                      <label>Phone:</label>
                      <input
                        type='number'
                        className={`form-control ${validation1.touched.phone && validation1.errors.phone ? 'is-invalid' : ''}`}
                        name="phone"
                        placeholder="1234567890"
                        value={validation1.values.phone || ''}
                        onChange={validation1.handleChange}
                        onBlur={validation1.handleBlur}
                        invalid={
                        validation1.touched.phone && validation1.errors.phone ? true : false
                        }
                        
                    />
                    {validation1.touched.phone && validation1.errors.phone ? (
                        <div className="invalid-feedback" >{validation1.errors.phone}</div>
                    ) : null}
                    </div>
                    {/* <div className='form-group mb-3 col-md-6 col-xs-12'>
                      <label>Aadhar Card:</label>
                      <input
                        type="text" 
                        inputMode="numeric" 
                        pattern="[0-9]*"
                        className={`form-control ${validation1.touched.aadhar && validation1.errors.aadhar ? 'is-invalid' : ''}`}
                            name="aadhar"
                            placeholder="Enter Aadhar Card No."
                            value={validation1.values.aadhar || ''}
                            onChange={validation1.handleChange}
                            onBlur={validation1.handleBlur}
                            invalid={
                            validation1.touched.aadhar && validation1.errors.aadhar ? true : false
                            }
                            
                        />
                        {validation1.touched.aadhar && validation1.errors.aadhar ? (
                            <div className="invalid-feedback" >{validation1.errors.aadhar}</div>
                        ) : null}
                    </div> */}
                  </div>
                  <button type='submit' className='btn btn-primary me-2'
                  id="submit1"onClick={(e) => {
                    e.preventDefault();
                    validation1.handleSubmit();
                    return false;
                  }}>
                  {('Add User')}
                  </button>
                  <Link to='/user-list' className='btn btn-light'>
                    Cancel
                  </Link>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
};

export default AddUser;